export const TIPO_AGRUPAMENTO = {
  CONTADOR: 1,
  SOMA: 2,
  AGRUPADOR: 3,
  MAXIMO: 4,
};
